import React from 'react';

function Testimonials() {
  const testimonials = [
    {
      imageSrc: 'assets/images/resources/testi-1-1.png',
      name: 'Delia Riley',
      designation: 'Business Owner',
      text: 'As a small business owner,it was difficult for me to get a business loan from traditional banks. ABC Loans worked closely with me and..'
    },
    {
      imageSrc: 'assets/images/resources/testi-1-2.png',
      name: 'Essie Perez',
      designation: 'First Time Home-Buyer',
      text:  `${process.env.REACT_APP_COMPANY_NAME} Loans made buying my first home so easy. Their low down payment program allowed me to finally achieve my...`
    },
    {
      imageSrc: 'assets/images/resources/testi-1-3.png',
      name: 'Dustin Dunn',
      designation: 'Vet',
      text: `The debt consolidation loan I got from ${process.env.REACT_APP_COMPANY_NAME} was a total lifesaver. By combining all my high interest credit card...`
    }
  ];

  return (
    <>
      <section className="testimonials-one pt-120 mb--40">
        <div className="container">
          <div className="block-title text-center">
            <p className="block-title__tagline">our testimonials</p>
            <h2 className="block-title__title">
              What they’re talking about <br /> our company
            </h2>
          </div>
          <div className="row row-gutter-y-30">
            {testimonials.map((testimonial, index) => (
              <div
                className="col-lg-4 col-md-12 wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay={`${index * 100}ms`}
                key={index}
              >
                <div className="testimonial-card">
                  <div className="testimonial-card__info">
                    <div className="testimonial-card__image">
                      <img src={testimonial.imageSrc} alt={testimonial.name} />
                    </div>
                    <div className="testimonial-card__meta">
                      <div className="testimonial-card__stars">
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                        <i className="fa fa-star"></i>
                      </div>
                      <h3 className="testimonial-card__name">{testimonial.name}</h3>
                      <p className="testimonial-card__designation">{testimonial.designation}</p>
                    </div>
                  </div>
                  <span className="testimonial-card__line"></span>
                  <div className="testimonial-card__text">
                    <p>{testimonial.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Testimonials;
